// extracted by css-extract-rspack-plugin
export default {"slideUp":"src-pages-Privacy-PrivacyPopup-module__slideUp-gQ8lYa","slideDown":"src-pages-Privacy-PrivacyPopup-module__slideDown-xlTH2z","acceptButton":"src-pages-Privacy-PrivacyPopup-module__acceptButton-_59aGZ","declineButton":"src-pages-Privacy-PrivacyPopup-module__declineButton-wYig3i"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"slideUp\":\"src-pages-Privacy-PrivacyPopup-module__slideUp-gQ8lYa\",\"slideDown\":\"src-pages-Privacy-PrivacyPopup-module__slideDown-xlTH2z\",\"acceptButton\":\"src-pages-Privacy-PrivacyPopup-module__acceptButton-_59aGZ\",\"declineButton\":\"src-pages-Privacy-PrivacyPopup-module__declineButton-wYig3i\"}";
        // 1772473572964
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  